import useAppContext from "@casino/legacy/shared/context/AppContext/useAppContext";

const useFeatures = () => {
  const { featureFlags = {} } = useAppContext();
  return featureFlags;
};

export default useFeatures;
